import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TaApiService } from '@shared/services/ta-api.service';
import { ApiCallService } from '@shared/services/api-call.service';

@Component({
  selector: 'confirm-delete-with-note-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, TextareaModule],
  template: `
    <div class="flex flex-col gap-3 p-2">
      <p>Nhập ghi chú (tuỳ chọn) trước khi xóa.</p>
      <textarea pTextarea [(ngModel)]="note" rows="3" class="w-full"></textarea>
      <div class="flex justify-end gap-2 mt-2">
        <button pButton type="button" label="Hủy" class="p-button-text" (click)="onCancel()"></button>
        <button pButton type="button" label="Xóa" severity="danger" (click)="onConfirm()"></button>
      </div>
    </div>
  `
})
export class ConfirmDeleteWithNoteDialogComponent {
  note: string = '';
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private taApi: TaApiService,
    private apiCall: ApiCallService,
  ) { }

  onCancel() { this.ref.close(false); }

  async onConfirm() {
    const id = (this.config?.data as any)?.id;
    if (!id) { this.ref.close(false); return; }
    const note = this.note?.trim() || null;
    const { success } = await this.apiCall.execute(
      this.taApi.deleteTaShiftTime(id, { note }),
      'Xóa ca trực thành công'
    );
    if (success) {
      this.ref.close(true);
    }
  }
}
